<template>
  <span>
    <span v-for="n in numero_stelle" :key="'stella-piena-' + n">
      <feather-icon icon="StarIcon" class="text-warning" />
    </span>
    <span v-for="n in stelleVuote" :key="'stella-vuota-' + n">
      <feather-icon icon="StarIcon" class="text-muted" />
    </span>
  </span>
</template>

<script>
export default {
  props: {
    numero_stelle: {
      type: Number,
      required: true,
    },
    max_stelle: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    stelleVuote() {
      return this.max_stelle - this.numero_stelle;
    },
  },
};
</script>
